import { TenantEntity } from '../TenantEntity'
import { loadQuotationClientRelated } from '@/api/sales/quotationClient'

export class QuotationClient extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'QuotationClient'
  }

  get clientId() {
    return this._data.clientId
  }
  set clientId(clientId) {
    this._data.clientId = clientId || 0
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get ownerId() {
    return this._data.ownerId
  }
  set ownerId(ownerId) {
    this._data.ownerId = ownerId || 0
  }
  get preOwnerId() {
    return this._data.preOwnerId
  }
  set preOwnerId(preOwnerId) {
    this._data.preOwnerId = preOwnerId || 0
  }
  get name() {
    return this._data.name
  }
  set name(name) {
    this._data.name = name
  }
  get contact() {
    return this._data.contact
  }
  set contact(contact) {
    this._data.contact = contact
  }
  get phone() {
    return this._data.phone
  }
  set phone(phone) {
    this._data.phone = phone
  }
  get fax() {
    return this._data.fax
  }
  set fax(fax) {
    this._data.fax = fax
  }
  get email() {
    return this._data.email
  }
  set email(email) {
    this._data.email = email
  }
  get address() {
    return this._data.address
  }
  set address(address) {
    this._data.address = address
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get englishName() {
    return this._data.englishName
  }
  set englishName(englishName) {
    this._data.englishName = englishName
  }
  get companySize() {
    return this._data.companySize
  }
  set companySize(companySize) {
    this._data.companySize = companySize
  }
  get registeredCapital() {
    return this._data.registeredCapital
  }
  set registeredCapital(registeredCapital) {
    this._data.registeredCapital = registeredCapital
  }
  get departmentId() {
    return this._data.departmentId
  }
  set departmentId(departmentId) {
    this._data.departmentId = departmentId || 0
  }
  get groupLeaderId() {
    return this._data.groupLeaderId
  }
  set groupLeaderId(groupLeaderId) {
    this._data.groupLeaderId = groupLeaderId || 0
  }
  get assignDate() {
    return this._data.assignDate
  }
  set assignDate(assignDate) {
    this._data.assignDate = assignDate
  }
  get companyTypeCode() {
    return this._data.companyTypeCode
  }
  set companyTypeCode(companyTypeCode) {
    this._data.companyTypeCode = companyTypeCode || 0
  }
  get customerStatusCode() {
    return this._data.customerStatusCode
  }
  set customerStatusCode(customerStatusCode) {
    this._data.customerStatusCode = customerStatusCode || 0
  }
  get customerLevelCode() {
    return this._data.customerLevelCode
  }
  set customerLevelCode(customerLevelCode) {
    this._data.customerLevelCode = customerLevelCode || 0
  }
  get overcomeLevelCode() {
    return this._data.overcomeLevelCode
  }
  set overcomeLevelCode(overcomeLevelCode) {
    this._data.overcomeLevelCode = overcomeLevelCode || 0
  }
  get firstMeetDate() {
    return this._data.firstMeetDate
  }
  set firstMeetDate(firstMeetDate) {
    this._data.firstMeetDate = firstMeetDate
  }
  get sleepDays() {
    return this._data.sleepDays
  }
  set sleepDays(sleepDays) {
    this._data.sleepDays = sleepDays
  }
  get signed() {
    return this._data.signed
  }
  set signed(signed) {
    this._data.signed = signed
  }
  get signedDays() {
    return this._data.signedDays
  }
  set signedDays(signedDays) {
    this._data.signedDays = signedDays
  }
  get dueTime() {
    return this._data.dueTime
  }
  set dueTime(dueTime) {
    this._data.dueTime = dueTime
  }
  get competitorCompany() {
    return this._data.competitorCompany
  }
  set competitorCompany(competitorCompany) {
    this._data.competitorCompany = competitorCompany
  }
  get country() {
    return this._data.country
  }
  set country(country) {
    this._data.country = country || ''
  }
  get province() {
    return this._data.province
  }
  set province(province) {
    this._data.province = province
  }
  get city() {
    return this._data.city
  }
  set city(city) {
    this._data.city = city
  }
  get districts() {
    return this._data.districts
  }
  set districts(districts) {
    this._data.districts = districts
  }
  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid
  }
  get active() {
    return this._data.active
  }
  set active(active) {
    this._data.active = active
  }
  get approvedState() {
    return this._data.approvedState
  }
  set approvedState(approvedState) {
    this._data.approvedState = approvedState
  }
  get sourceType() {
    return this._data.sourceType
  }
  set sourceType(sourceType) {
    this._data.sourceType = sourceType
  }
  get unAskDays() {
    return this._data.unAskDays
  }
  set unAskDays(unAskDays) {
    this._data.unAskDays = unAskDays
  }
  get customerContactChannel() {
    return this._data.customerContactChannel
  }
  set customerContactChannel(customerContactChannel) {
    this._data.customerContactChannel = customerContactChannel
  }

  /* =============扩展属性================= */
  get dueTime2() {
    return this._data.dueTime2
  }
  set dueTime2(dueTime2) {
    this._data.dueTime2 = dueTime2
  }

  // 询价客户和联系人
  get quotationClientContact() {
    return this._data.quotationClientContact
  }
  set quotationClientContact(quotationClientContact) {
    this._data.quotationClientContact = quotationClientContact
  }
  // 询价客户和业务
  get quotationClientBusiness() {
    return this._data.quotationClientBusiness
  }
  set quotationClientBusiness(quotationClientBusiness) {
    this._data.quotationClientBusiness = quotationClientBusiness
  }
  // 询价客户和事件记录
  get quotationClientEvent() {
    return this._data.quotationClientEvent
  }
  set quotationClientEvent(quotationClientEvent) {
    this._data.quotationClientEvent = quotationClientEvent
  }
  // 加载QuotationClient的关联实体信息
  async loadQuotationClientRelated(params) {
    params.quotationClientUuid = params.quotationClientUuid || this._data.uuid
    if (!params.quotationClientUuid) return
    // 是否需要载入
    let needLoad = false
    // 将已经加载过的属性的标识置为false
    for (const key in params) {
      if (key === 'quotationClientUuid') {
        continue
      }
      if (key !== 'client' && params[key] && typeof this._data[key] === 'object') {
        params[key] = false
      }
      if (params[key]) {
        needLoad = true
      }
    }
    if (!needLoad) {
      return
    }
    await loadQuotationClientRelated(params).then(res => {
      const items = res.data
      if (items.client) {
        for (const key in items.client) {
          if (typeof this._data[key] === 'object') {
            continue
          }
          this._data[key] = items.client[key]
        }
      }
      for (const key in items) {
        if (key === 'client') {
          continue
        }
        this._data[key] = items[key] || null
      }
    })
  }
}
